import { AlertCircle, CheckCircle, XCircle } from 'lucide-react';
import { cn } from '@/lib/utils';

interface CheckStatus {
  checkId: string;
  name: string;
  status: 'clear' | 'match' | 'error';
}

interface CheckStatusTableProps {
  checkStatuses: CheckStatus[];
}

const STATUS_CONFIG = {
  clear: {
    icon: CheckCircle,
    label: 'Clear',
    bgColor: 'bg-green-50',
    textColor: 'text-green-700',
    iconColor: 'text-green-600',
  },
  match: {
    icon: AlertCircle,
    label: 'Match Found',
    bgColor: 'bg-amber-50',
    textColor: 'text-amber-700',
    iconColor: 'text-amber-600',
  },
  error: {
    icon: XCircle,
    label: 'Error',
    bgColor: 'bg-red-50',
    textColor: 'text-red-700',
    iconColor: 'text-red-600',
  },
};

export function CheckStatusTable({ checkStatuses }: CheckStatusTableProps) {
  return (
    <div className="overflow-hidden rounded-lg border border-gray-200">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th scope="col" className="px-4 py-3 text-left text-sm font-medium text-gray-900">
              Check
            </th>
            <th scope="col" className="px-4 py-3 text-left text-sm font-medium text-gray-900">
              Status
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200 bg-white">
          {checkStatuses.map((check) => {
            const config = STATUS_CONFIG[check.status];
            const Icon = config.icon;

            return (
              <tr key={check.checkId}>
                <td className="whitespace-nowrap px-4 py-3 text-sm text-gray-900">{check.name}</td>
                <td className="whitespace-nowrap px-4 py-3">
                  <span
                    className={cn(
                      'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium',
                      config.bgColor,
                      config.textColor,
                    )}
                  >
                    <Icon className={cn('h-3.5 w-3.5', config.iconColor)} />
                    {config.label}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
